export const formatDateRange = (start: string, end: string) => {
  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
    year: "numeric",
  };

  const parseDateOnly = (dateString: string) => {
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  const startDate = parseDateOnly(start).toLocaleDateString("en-US", options);
  const endDate = parseDateOnly(end).toLocaleDateString("en-US", options);

  return `${startDate} - ${endDate}`;
};

export const formatChange = (value: number | string, suffix = "%") => {
  const num = Number(value || 0);
  if (num === 0) return `0${suffix}`;
  return `${num > 0 ? "+" : ""}${num.toFixed(1)}${suffix}`;
};

export const stripMarkdownAndHTML = (input: string) => {
  if (!input) return "";
  let output = input.replace(/<[^>]*>/g, "");
  output = output
    .replace(/(\*{1,2}|_{1,2}|`|~{1,2})/g, "")
    .replace(/\[(.*?)\]\(.*?\)/g, "$1");
  return output.trim();
};

export const formatDate = (date: Date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

export const formatCamelCase = (key: string) => {
  return key
    .replace(/([A-Z])/g, " $1")
    .trim()
    .toUpperCase();
};
